import { gql } from '@apollo/client';

import USER_FRAGMENT from '../fragments/user';

const GET_BASE_USER_QUERY = gql`
  query getBaseUser($id: Int!) {
    entity: user(where: { id: $id }) {
      ...BaseUser
    }
  }
  ${USER_FRAGMENT}
`;

export default GET_BASE_USER_QUERY;
